import { TenantEntity } from '../TenantEntity'

export class AutomationTask extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get taskName() {
    return this._data.taskName
  }

  set taskName(taskName) {
    this._data.taskName = taskName
  }

  get automationConfigUuid() {
    return this._data.automationConfigUuid
  }

  set automationConfigUuid(automationConfigUuid) {
    this._data.automationConfigUuid = automationConfigUuid
  }

  get type() {
    return this._data.type
  }

  set type(type) {
    this._data.type = type
  }

  get startHour() {
    return this._data.startHour
  }

  set startHour(startHour) {
    this._data.startHour = startHour
  }

  get lastDay() {
    return this._data.lastDay
  }

  set lastDay(lastDay) {
    this._data.lastDay = lastDay
  }
  get hour() {
    return this._data.hour
  }

  set hour(hour) {
    this._data.hour = hour
  }

  get week() {
    return this._data.week
  }

  set week(week) {
    this._data.week = week
  }

  get day() {
    return this._data.day
  }

  set day(day) {
    this._data.day = day
  }

  get effectiveDateStart() {
    return this._data.effectiveDateStart
  }

  set effectiveDateStart(effectiveDateStart) {
    this._data.effectiveDateStart = effectiveDateStart
  }

  get effectiveDateEnd() {
    return this._data.effectiveDateEnd
  }

  set effectiveDateEnd(effectiveDateEnd) {
    this._data.effectiveDateEnd = effectiveDateEnd
  }

  get taskResult() {
    return this._data.taskResult
  }

  set taskResult(taskResult) {
    this._data.taskResult = taskResult
  }

  get taskResultUser() {
    return this._data.taskResultUser
  }

  set taskResultUser(taskResultUser) {
    this._data.taskResultUser = taskResultUser
  }

  get taskResultUserList() {
    return this._data.taskResultUserList
  }

  set taskResultUserList(taskResultUserList) {
    this._data.taskResultUserList = taskResultUserList
  }

  get weekList() {
    return this._data.weekList
  }

  set weekList(weekList) {
    this._data.weekList = weekList
  }

  get dayList() {
    return this._data.dayList
  }

  set dayList(dayList) {
    this._data.dayList = dayList
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks
  }

  get tipMessage() {
    return this._data.tipMessage
  }

  set tipMessage(tipMessage) {
    this._data.tipMessage = tipMessage
  }

  get cron() {
    return this._data.cron
  }

  set cron(cron) {
    this._data.cron = cron
  }

  get executionStatus() {
    return this._data.executionStatus
  }

  set executionStatus(executionStatus) {
    this._data.executionStatus = executionStatus
  }

  get jobId() {
    return this._data.jobId
  }

  set jobId(jobId) {
    this._data.jobId = jobId
  }

  get executionDate() {
    return this._data.executionDate
  }

  set executionDate(executionDate) {
    this._data.executionDate = executionDate
  }

  get branchId() {
    return this._data.branchId
  }

  set branchId(branchId) {
    this._data.branchId = branchId
  }
}
